import { useCallback } from 'react';
import { useToast } from '@kcd/design-system';

import { SectionDivider } from '~/components/SectionDividor';
import CartCard from '~/domains/cart/components/CartCard';
import { useDeleteUnbuyableShoppingCartItem } from '~/domains/cart/queries';
import { getOAIErrorMessage } from '~/libs/openapi';
import { OAIApiError } from '~/libs/openApiError';
import type { OAISchema } from '~/types/openapi';

type Props = {
  data: OAISchema['MarketShoppingCartItemResponseV2'][];
};

const UnbuyableShoppingCartGroup = ({ data }: Props) => {
  const mutate = useDeleteUnbuyableShoppingCartItem();
  const toast = useToast();

  const onDeleteClick = useCallback(
    (shoppingCartItemId: number) => {
      try {
        void mutate({ shoppingCartItemId });
      } catch (err) {
        if (err instanceof OAIApiError) {
          const errMessage = getOAIErrorMessage(err);
          toast(errMessage);
          return;
        }
        throw err;
      }
    },
    [mutate, toast],
  );

  if (!data.length) return null;

  return (
    <>
      <section className="px-20 py-16">
        <strong className="h-56 typo-title100-semibold">구매 불가 상품</strong>
        {data.map((item) => {
          return (
            <CartCard
              className="opacity-50"
              item={item}
              key={item.offerId}
              visibleCheckbox={false}
              onDeleteClick={() => onDeleteClick(item.shoppingCartItemId!)}
            />
          );
        })}
      </section>
      <SectionDivider />
    </>
  );
};

export default UnbuyableShoppingCartGroup;
